import React from 'react';
import {Button, Paper, Typography, Box} from '@mui/material';

import {themeColors} from '../../theme/Theme';

type ReportPackFormItemProps = {
  title: string;
  onAdd: () => void;
};

export const ReportPackAddFormItem: React.FC<ReportPackFormItemProps> = ({
  title,
  onAdd,
}) => {
  return (
    <Paper
      elevation={1}
      sx={{
        alignItems: 'center',
        borderRadius: '8px',
        background: themeColors.white,
        display: 'flex',
        justifyContent: 'space-between',
        padding: 2,
        width: '100%',
      }}
    >
      <>
        <Box>
          <Typography variant="h6" sx={{fontWeight: 'bold'}}>
            {title}
          </Typography>
        </Box>

        <Box sx={{display: 'flex', gap: 2}}>
          <Button color="primary" onClick={() => onAdd()} variant="outlined">
            Add
          </Button>
        </Box>
      </>
    </Paper>
  );
};
